export default JSON.stringify({
  refreshToken: 'asgsdfgs',
  data: [
    {
      name: 'Test property 01',
      id: 'testproperty01',
    },
    {
      name: 'Test property 02',
      id: 'testsite02',
    },
  ],
})
